import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { WebApiResponse } from '../api/models/api-model';

@Injectable({
	providedIn: 'root'
})
export class NotificationProxyService {

	constructor(private http: HttpClient) { }

	public registerDevice(fcmToken: string): Observable<WebApiResponse<void>> {
		const url = `${environment.api.fasttrackApi}/services/app/Notification/RegisterDevice?fcmToken=${fcmToken}&clientId=web`;

		return this.http.post<WebApiResponse<void>>(url, {});
	}

	public unregisterDevice(): Observable<WebApiResponse<void>> {
		const url = `${environment.api.fasttrackApi}/services/app/Notification/UnregisterDevice?clientId=web`;

		return this.http.post<WebApiResponse<void>>(url, {});
	}
}
